// extracted by mini-css-extract-plugin
export default {"itemDetailsWrapper":"ItemList_itemDetailsWrapper__B-Rrs","itemTable":"ItemList_itemTable__O3gSE"};